module.exports = __webpack_public_path__ + "static/fonts/iconfont.2e144e5c.ttf";